import { guessTimeZone } from "@eroad/helpers/guessTimeZone";
import type { TimeZone, TimeZoneKey, TimeZones } from "@eroad/types";

import { AU_TIMEZONES } from "./AU";
import { CA_TIMEZONES } from "./CA";
import { NA_TIMEZONES } from "./NA";
import { NZ_TIMEZONES } from "./NZ";

/**
 * We can't rely only on `Intl.DateTimeFormat().resolvedOptions().timeZone` to get the user's timezone as
 * `Intl.DateTimeFormat().resolvedOptions().timeZone` returns `undefined` is some version of Chrome.
 * It has been fixed starting from Chrome 118.0.5993.88 (release October 17, 2023).
 *
 * @see https://github.com/microsoft/TypeScript/issues/55869
 */
const TIMEZONE_USER = Intl.DateTimeFormat().resolvedOptions().timeZone || guessTimeZone();
const TIMEZONE_NZ = "Pacific/Auckland";
const TIMEZONE_UTC = "Etc/UTC";

/**
 * To be replaced with `TIMEZONES_NEW` once FED-1071 is done.
 *
 * @deprecated
 */
const TIMEZONES: Record<TimeZoneKey, Omit<TimeZone, "cities" | "timeZone">[]> = {
  AU: [
    { name: "New South Wales", value: "Australia/Sydney" },
    { name: "Northern Territory", value: "Australia/Darwin" },
    { name: "Queensland", value: "Australia/Brisbane" },
    { name: "South Australia", value: "Australia/Adelaide" },
    { name: "Western Australia", value: "Australia/Perth" },
  ],
  CA: [
    { name: "Atlantic time", value: "Canada/Atlantic" },
    { name: "Central time", value: "Canada/Central" },
    { name: "Eastern time", value: "Canada/Eastern" },
    { name: "Mountain time", value: "Canada/Mountain" },
    { name: "Newfoundland time", value: "Canada/Newfoundland" },
    { name: "Pacific time", value: "Canada/Pacific" },
  ],
  NA: [
    { name: "Alaska time", value: "US/Alaska" },
    { name: "Arizona", value: "US/Arizona" },
    { name: "Central time", value: "America/Chicago" },
    { name: "Eastern time", value: "America/New_York" },
    { name: "Hawaii", value: "US/Hawaii" },
    { name: "Mountain time", value: "America/Denver" },
    { name: "Pacific time", value: "America/Los_Angeles" },
  ],
  NZ: [{ name: "New Zealand", value: "Pacific/Auckland" }],
};

const TIMEZONES_NEW: TimeZones = {
  AU: AU_TIMEZONES,
  CA: CA_TIMEZONES,
  NA: NA_TIMEZONES,
  NZ: NZ_TIMEZONES,
};

export { TIMEZONE_NZ, TIMEZONE_USER, TIMEZONE_UTC, TIMEZONES, TIMEZONES_NEW };
